import client from './client';

// --- Auth ---
export const login = (data) => client.post('/users/login', data).then((r) => r.data);
export const getMe = () => client.get('/users/me').then((r) => r.data);

// --- Uploads (returns { urls }) ---
export const uploadFiles = (files) => {
  const fd = new FormData();
  files.forEach((f) => fd.append('files', f));
  return client
    .post('/uploads', fd, { headers: { 'Content-Type': 'multipart/form-data' } })
    .then((r) => r.data.urls);
};

// Given a mixed array of url-strings and File objects, upload the Files and
// return a pure array of urls (existing urls kept in order-ish: urls first).
export const resolveImages = async (mixed = []) => {
  const urls = mixed.filter((m) => typeof m === 'string');
  const files = mixed.filter((m) => typeof m !== 'string');
  const uploaded = files.length ? await uploadFiles(files) : [];
  return [...urls, ...uploaded];
};

// --- Settings ---
export const getSettings = () => client.get('/settings').then((r) => r.data);
export const updateSettings = (data) =>
  client.put('/settings', data).then((r) => r.data);

// --- Banners ---
export const getBanners = (activeOnly = false) =>
  client.get('/banners', { params: activeOnly ? { activeOnly: true } : {} }).then((r) => r.data);
export const createBanner = (data) => client.post('/banners', data).then((r) => r.data);
export const updateBanner = (id, data) => client.put(`/banners/${id}`, data).then((r) => r.data);
export const deleteBanner = (id) => client.delete(`/banners/${id}`).then((r) => r.data);

// --- Categories (hierarchical) ---
export const getCategoryList = (params = {}) =>
  client.get('/categories', { params }).then((r) => r.data);
export const getRootCategories = () =>
  client.get('/categories', { params: { parent: 'root', activeOnly: true } }).then((r) => r.data);
export const getLeafCategories = (activeOnly = false) =>
  client.get('/categories', { params: { leaf: true, ...(activeOnly ? { activeOnly: true } : {}) } }).then((r) => r.data);
export const getCategory = (idOrSlug) => client.get(`/categories/${idOrSlug}`).then((r) => r.data);
export const createCategory = (data) => client.post('/categories', data).then((r) => r.data);
export const updateCategory = (id, data) => client.put(`/categories/${id}`, data).then((r) => r.data);
export const deleteCategory = (id) => client.delete(`/categories/${id}`).then((r) => r.data);

// --- Section items (home: features/process/industries/why) ---
export const getSectionItems = (section, activeOnly = false) =>
  client.get('/section-items', { params: { section, ...(activeOnly ? { activeOnly: true } : {}) } }).then((r) => r.data);
export const createSectionItem = (data) => client.post('/section-items', data).then((r) => r.data);
export const updateSectionItem = (id, data) => client.put(`/section-items/${id}`, data).then((r) => r.data);
export const deleteSectionItem = (id) => client.delete(`/section-items/${id}`).then((r) => r.data);

// --- Testimonials ---
export const getTestimonials = (activeOnly = false) =>
  client.get('/testimonials', { params: activeOnly ? { activeOnly: true } : {} }).then((r) => r.data);
export const createTestimonial = (data) => client.post('/testimonials', data).then((r) => r.data);
export const updateTestimonial = (id, data) => client.put(`/testimonials/${id}`, data).then((r) => r.data);
export const deleteTestimonial = (id) => client.delete(`/testimonials/${id}`).then((r) => r.data);

// --- Products ---
export const getProducts = (params = {}) =>
  client.get('/products', { params }).then((r) => r.data);
export const getProduct = (idOrSlug) => client.get(`/products/${idOrSlug}`).then((r) => r.data);
export const getCategories = () => client.get('/products/meta/categories').then((r) => r.data);
export const createProduct = (data) => client.post('/products', data).then((r) => r.data);
export const updateProduct = (id, data) => client.put(`/products/${id}`, data).then((r) => r.data);
export const deleteProduct = (id) => client.delete(`/products/${id}`).then((r) => r.data);

// --- Services ---
export const getServices = (params = {}) =>
  client.get('/services', { params }).then((r) => r.data);
export const getService = (idOrSlug) => client.get(`/services/${idOrSlug}`).then((r) => r.data);
export const createService = (data) => client.post('/services', data).then((r) => r.data);
export const updateService = (id, data) => client.put(`/services/${id}`, data).then((r) => r.data);
export const deleteService = (id) => client.delete(`/services/${id}`).then((r) => r.data);

// --- Form fields ---
export const getFormFields = (activeOnly = false) =>
  client.get('/form-fields', { params: activeOnly ? { activeOnly: true } : {} }).then((r) => r.data);
export const createFormField = (data) => client.post('/form-fields', data).then((r) => r.data);
export const updateFormField = (id, data) =>
  client.put(`/form-fields/${id}`, data).then((r) => r.data);
export const deleteFormField = (id) => client.delete(`/form-fields/${id}`).then((r) => r.data);

// --- Queries ---
export const submitQuery = (data) => client.post('/queries', data).then((r) => r.data);
export const getQueries = (params = {}) =>
  client.get('/queries', { params }).then((r) => r.data);
export const updateQuery = (id, data) => client.put(`/queries/${id}`, data).then((r) => r.data);
export const deleteQuery = (id) => client.delete(`/queries/${id}`).then((r) => r.data);
